import * as React from 'react'
import { TenantContext } from '../../contexts'

export const useTenant = () => {
  const tenant = React.useContext(TenantContext)
  return tenant
}
